import { ORG_PERMISSION_ORDERING } from '../../constants';
import { Member } from '../../types';

export const roleText = (member: Member) => (member?.orgAdmin ? 'Org Admin' : 'Org Member');

export const permissionsText = (member: Member) => {
  const numPermissions = member?.organizationPermissions?.length || 0;
  return `${numPermissions} org permission${numPermissions === 1 ? '' : 's'}`;
};

export const sortedOrgPermissions = (member: Member) => {
  return member?.organizationPermissions
    ? [...member.organizationPermissions].sort(
        (a, b) => ORG_PERMISSION_ORDERING[a] - ORG_PERMISSION_ORDERING[b],
      )
    : [];
};
